import { useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import helpIcon from "../icons/help_icon.gif";

const toastOptions = {
  position: "bottom-right",
  className: "note-background",
  autoClose: false,
  hideProgressBar: false,
  closeOnClick: false,
  pauseOnHover: true,
  draggable: false,
  progress: undefined,
};

const CustomToast = ({ msg }) => {
  return (
    <div className="flex">
      <img
        className="w-12 h-12 rounded-full mr-4"
        src={helpIcon}
        alt="Help icon"
      />
      <div className="text-sm">
        <p className="text-gray-900 leading-relaxed font-bold">{msg}</p>
      </div>
    </div>
  );
};

const displayToast = (msg, id) => {
  toast.success(<CustomToast msg={msg} />, {
    ...toastOptions,
    toastId: id,
  });
};

const HelpToaster = () => {
  useEffect(() => {
    displayToast(
      "You can use your mouse to click on an area of interest or search a post code using the search bar above",
      "help-notification-1"
    );
  }, []);

  return <ToastContainer icon={false} />;
};

export { HelpToaster };
